// /src/modules/Brand/store.js
import { resolveRequestBrand } from './requestBrand'
export default {
  namespaced: true,

  state: {
    currentBrand: 'storesync',
    config: {}
  },

  mutations: {
    SET_BRAND(state, payload) {
      state.currentBrand = payload
    },
    SET_CONFIG(state, payload) {
      state.config = payload
    }
  },

  getters: {
    currentBrand: (state) => state.currentBrand,
    brandConfig: (state) => state.config,
    isTouchBrand: (state) => state.config?.isTouchBrand || false
  },

  actions: {
    initBrand({ commit, state }) {
      const host = window.location.hostname.toLowerCase()
      const nativeBrand = process.env.VUE_APP_NATIVE_MOBILE === 'true'
        ? String(process.env.VUE_APP_MOBILE_BRAND || '').toLowerCase()
        : ''
      const mobileBrand = nativeBrand === 'autorepairdesk' ? 'autorepair' : nativeBrand
      const brand = ['repairnest', 'storesync', 'autorepair'].includes(mobileBrand)
        ? mobileBrand
        : (resolveRequestBrand(host, state.currentBrand) || 'repairnest')

      commit('SET_BRAND', brand)
      document.documentElement.setAttribute("data-brand", brand);

      // Brand Configs with three logos per brand
      const configs = {
        storesync: {
          urls: {
            terminal: 'https://app.storesyncpos.com',
          },
          logos: {
            inline: require('@/assets/icons/logo/brand/storesync/inlinelogo.png'),
            square: require('@/assets/icons/logo/brand/storesync/squarelogo.png'),
            icon: require('@/assets/icons/logo/brand/storesync/icon.png')
          },
          theme: {
            primary: '#003366',
            secondary: '#e5eaf0',
            accent: '#6699cc',
            error: '#ff4d4d',
            info: '#b0b0b0',
            warning: '#ffab00',
            success: '#00c853',
            innerCard: '#f3f5f8',
            subCard: '#fafafb'
          },
          isTouchBrand: true,
          themeVars: {
            '--brand-primary': '#003366',
            '--brand-secondary': '#e5eaf0',
            '--brand-accent': '#6699cc',
            '--brand-bg': '#f4f6fa',
            '--brand-text': '#1a1a1a'
          }
        },

        autorepair: {
          urls: {
            terminal: 'https://app.autorepairdesk.com',
          },
          logos: {
            inline: require('@/assets/icons/logo/brand/autorepair/inlinelogo.png'),
            square: require('@/assets/icons/logo/brand/autorepair/squarelogo.png'),
            icon: require('@/assets/icons/logo/brand/autorepair/icon.png')
          },
          theme: {
            primary: '#D32F2F',
            secondary: '#E8E2F2',
            accent: '#B8E2F2',
            error: '#FC4161',
            info: '#C0C0C0',
            warning: '#FFA826',
            success: '#21BED5',
            innerCard: '#E8E2F2',
            subCard: '#F6F5F9'
          },
          isTouchBrand: false,
          themeVars: {
            '--brand-primary': '#D32F2F',
            '--brand-secondary': '#E8E2F2',
            '--brand-accent': '#B8E2F2',
            '--brand-bg': '#f4f6fa',
            '--brand-text': '#1a1a1a'
          }
        },

        repairnest: {
          urls: {
            terminal: 'https://soft.repairnestpos.com',
          },
          logos: {
            inline: require('@/assets/icons/logo/brand/repairnest/inlinelogo.png'),
            square: require('@/assets/icons/logo/brand/repairnest/squarelogo.png'),
            icon: require('@/assets/icons/logo/brand/repairnest/icon.png')
          },
          theme: {
            primary: '#004D40',
            secondary: '#26A69A',
            accent: '#b39ddb',
            error: '#e53935',
            info: '#9e9e9e',
            warning: '#ffb300',
            success: '#43a047',
            innerCard: '#B2DFDB',
            subCard: '#E0F2F1'
          },
          isTouchBrand: false,
          themeVars: {
            '--brand-primary': '#004D40',
            '--brand-secondary': '#26A69A',
            '--brand-accent': '#b39ddb',
            '--brand-bg': '#f4f6fa',
            '--brand-text': '#1a1a1a'
          }
        }
      }

      commit('SET_CONFIG', configs[brand])
      const vars = configs[brand].themeVars
      Object.entries(vars).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value)
      })
    }
  }
}
